import React from 'react';
import { ApprovalStatus } from '../types';
import {
    faCheck,
    faExclamation,
    faX,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../styles/components/ApprovalCheckBox.scss';

interface ApprovalCheckBoxProps {
    status?: ApprovalStatus;
    invert?: boolean;
}

// Color definitions matching the approval status text colors
const STATUS_COLORS = {
    [ApprovalStatus.APPROVED]: '#389E0D',
    [ApprovalStatus.REJECTED]: '#D52214',
    [ApprovalStatus.REFERRED]: '#E0B80E',
};

// Map of approval status to icon information
const STATUS_ICONS = {
    [ApprovalStatus.APPROVED]: faCheck,
    [ApprovalStatus.REJECTED]: faX,
    [ApprovalStatus.REFERRED]: faExclamation,
};

// Convert hex to rgba
const hexToRGBA = (hex: string, alpha: number): string => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const ApprovalCheckBox: React.FC<ApprovalCheckBoxProps> = ({ status, invert = true }) => {
    // Get configuration based on status
    if (!status) {
        return <div className="approval-checkbox empty"></div>;
    }

    const color = STATUS_COLORS[status];
    const icon = STATUS_ICONS[status];

    // Determine styles based on invert prop
    const styles = invert
        ? {
              // Inverted: colored icon, semi-transparent background and border
              borderColor: hexToRGBA(color, 0.6),
              backgroundColor: hexToRGBA(color, 0.1),
              iconColor: color,
          }
        : {
              // Non-inverted: white semi-transparent icon, solid background and border
              borderColor: color,
              backgroundColor: color,
              iconColor: 'rgba(255, 255, 255, 0.9)',
          };

    return (
        <div
            className="approval-checkbox"
            style={{
                borderColor: styles.borderColor,
                backgroundColor: styles.backgroundColor,
            }}
        >
            <FontAwesomeIcon icon={icon} style={{ color: styles.iconColor }} />
        </div>
    );
};

export default ApprovalCheckBox;
